<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
//柱形累叠图
// import echarts from 'echarts'
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "400px",
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData);
    },
    setOptions({ xAxisData, lineData } = {}) {
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: ["神经外科","普胸外科","口腔科","泌尿外科","耳鼻喉科","肿瘤外科","眼科",],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "一级手术",
            type: "bar",
            stack: "Ad",
            emphasis: {
              focus: "series",
            },
            data: [20, 25, 42, 35, 26, 19, 16],
          },
          {
            name: "二级手术",
            type: "bar",
            stack: "Ad",
            emphasis: {
              focus: "series",
            },
            data: [35, 29, 35, 26, 20, 32, 38],
          },
          {
            name: "三级手术",
            type: "bar",
            stack: "Ad",
            emphasis: {
              focus: "series",
            },
            data: [102, 115, 105, 91, 106, 86, 79],
          },
          {
            name: "四级手术",
            type: "bar",
            stack: "Ad",
            emphasis: {
              focus: "series",
            },
            data: [60, 32, 46, 52, 70, 59, 30],
          }
        ],
      });
    },
  },
};
</script>
